import Home from "../views/FrontTpl";
import Login from "../components/front/Login";
import Back from "../views/BackofficeTpl";
import Dashboard from "../components/backoffice/dashboard/Dashboard";
import Signatures from "../components/backoffice/signatures/Signatures";
import SignatureForm from "../components/backoffice/signatures/SignatureForm";
import SignaturesStatistics from "../components/backoffice/signatures/SignaturesStatistics";
import Statistics from "../components/backoffice/statistics/Statistics";
import Templates from "../components/backoffice/templates/Templates";
import Admin from "../components/backoffice/admin/Admin";
import AdminUserForm from "../components/backoffice/admin/AdminUserForm";
import PasswordReset from "../components/front/PasswordReset";

let routesConfig = [
	{
		path: '/',
		redirect: "/backoffice"
	},
	{
		//any non mapped path...
		path: '*',
		// instead of showing 404, redirect to backoffice...
		redirect: "/backoffice"
	},
	{
		path: '/front',
		name: 'Front',
		component: Home,
		redirect: "/front/login",
		children: [{
			path: 'login',
			meta: {title: "Login"},
			component: Login
		}, {
			path: 'pass-reset/:token',
			meta: {title: "Passwords reset"},
			component: PasswordReset
		}]
	},
	{
		path: '/backoffice',
		name: 'Back',
		component: Back,
		redirect: "/backoffice/dashboard",
		children: [{
			path: 'dashboard',
			meta: {title: "Dashboard"},
			component: Dashboard
		}, {
			path: 'signatures',
			meta: {title: "Signatures"},
			component: Signatures
		}, {
			path: 'signatures/add',
			meta: {title: "Signature Form"},
			component: SignatureForm
		}, {
			path: 'signatures/statistics/:uuid',
			meta: {title: "Signatures Statistics"},
			component: SignaturesStatistics
		},
			{
				path: 'templates',
				meta: {title: "Templates"},
				component: Templates
			}, {
			path: 'statistics',
			meta: {title: "Statistics"},
			component: Statistics
		}, {
			path: 'admin',
			meta: {title: "Admin"},
			component: Admin
		}, {
			path: 'admin/userForm/:uuid?',
			meta: {title: "Admin - user form"},
			component: AdminUserForm
		}, {
			path: 'admin/statistics/:user_uuid',
			meta: {title: "Admin - user statistics"},
			component: Statistics,
			// we want both static value with the uuid so we use function here
			props: (route) => ({user_uuid: route.params.user_uuid, isAdminView: true})
		}]
	}
];

export default routesConfig;